import apiFetch from '@wordpress/api-fetch'

// Die Akademie hat keine länderspezifischen Gegenstücke, das Popup würde dort
// nur auf fremde Seiten verweisen (inkl. Raidboxes-Technikdomain der Instanz).
const popupDisabledHosts = ['akademie.elovade.com', 'bbaq4fr.myrdbx.io']

const allowedCountryCodes = [
  'de',
  'en',
  'it',
  'se',
  'ch',
  'fr',
  'sv',
  'no',
  'dk',
  'fi',
  'is',
  'se-en',
  'gb',
  'us',
  'au',
  'ca',
  'nz',
  'ie',
]

const fetchVisitorCountry = async (countryCode = 'de') => {
  if (!allowedCountryCodes.includes(countryCode)) return null

  return apiFetch({
    path: `/dhsv/v1/visitorCountry?country_code=${encodeURIComponent(
      countryCode
    )}`,
  })
    .then(response => {
      if (response.visitorCountry) {
        return response.visitorCountry
      } else {
        return null
      }
    })
    .catch(error => {
      console.error('Error fetching visitor country:', error)
      return null
    })
}

const checkCountry = async () => {
  if (popupDisabledHosts.includes(window.location.hostname)) return

  const selectedLanguage = localStorage.getItem('selectedLanguage')
  if (selectedLanguage) return
  // Get user country from session storage
  const userCountry = sessionStorage.getItem('uc_user_country')
  let countryCode = 'empty'
  if (userCountry) {
    const userCountryObj = JSON.parse(userCountry)
    countryCode = userCountryObj.countryCode.toLowerCase()

    // Map Nordic countries to Swedish-English language
    const nordicCountries = ['no', 'dk', 'fi', 'is']
    if (nordicCountries.includes(countryCode)) {
      countryCode = 'se-en'
    }

    // Map English-speaking countries to English language
    const englishCountries = ['gb', 'us', 'au', 'ca', 'nz', 'ie']
    if (englishCountries.includes(countryCode)) {
      countryCode = 'en'
    }
  }
  const visitorCountryFresh = await fetchVisitorCountry(countryCode)
  if (
    visitorCountryFresh &&
    visitorCountryFresh.length > 1 &&
    visitorCountryFresh[1].length
  ) {
    // Create and insert popup HTML before body
    const popup = document.createElement('div')
    popup.classList.add('visitor-country-popup')
    popup.innerHTML = visitorCountryFresh[1]
    document.body.insertBefore(popup, document.body.firstChild)
    const select = document.querySelector('.visitor-country-popup select')
    if (select) {
      // Change select value actions
      select.addEventListener('change', e => {
        localStorage.setItem('selectedLanguage', e.target.value)
        // Change .flag image src
        const flagImg = document.querySelector('.flag')
        // Get selected value data attribute and select it to image
        flagImg.src = visitorCountryFresh[2][e.target.selectedIndex].flag
        flagImg.alt = visitorCountryFresh[2][e.target.selectedIndex].name
        // Change text of .popup-text
        const popupText = document.querySelector('.popup-text')
        popupText.innerHTML =
          visitorCountryFresh[2][e.target.selectedIndex].text
      })

      // Create flag image and insert it to popup
      const flagImg = document.createElement('img')
      flagImg.src = visitorCountryFresh[2][0].flag
      flagImg.alt = visitorCountryFresh[2][0].native_name
      flagImg.classList.add('flag')
      const selectContainer = document.querySelector('.select-container')
      selectContainer.insertBefore(flagImg, selectContainer.firstChild)
    }
    // Add click to button
    const button = document.querySelector(
      '.visitor-country-popup .language-button'
    )
    if (button) {
      button.addEventListener('click', () => {
        let url = visitorCountryFresh[2][select.selectedIndex].url
        if (url.endsWith('/')) {
          url = url.slice(0, -1)
        }
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = `https://${url}`
        }
        localStorage.setItem('selectedLanguage', select.value)
        window.location.replace(url)
      })
    }
    // Close popup button click
    const closePopup = document.querySelector('.close-popup')
    if (closePopup) {
      closePopup.addEventListener('click', () => {
        localStorage.setItem('selectedLanguage', 'true')
        popup.style.display = 'none'
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(checkCountry, 1000)
})
